import React,{useState} from 'react';
import { Redirect } from 'react-router-dom'//yarn add @types/react-router-dom
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import ShareIcon from '@mui/icons-material/Share';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import TwitterIcon from '@mui/icons-material/Twitter';
import GoogleIcon from '@mui/icons-material/Google';
import FacebookIcon from '@mui/icons-material/Facebook';
import Ajax from './Ajax';
import useStyles from './Styles';
import {Tools} from './Tools';
//import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

interface Props {
	change(data:any):void,
}

interface State {
	unique_id: string,
	password: string,
}

const Login:React.FC<Props> = (props)=> {
	const classes = useStyles();
	const [values,setValues] = useState({
		unique_id:"",
		password:"",
	});
	const [error,setError] = useState("");
	const [isFinished,setIsFinished] = useState(false);
	const handleChange = (name: keyof State) => (event: React.ChangeEvent<HTMLInputElement>) => {
		setValues({ ...values, [name]: event.target.value });
	};
	const change = ()=>{
		const unique_id = Tools.toHan(values.unique_id);
		const password = Tools.toHan(values.password);
		Ajax.send("main/login",{unique_id:unique_id,password:password},(res:any)=>{
			if( res.ok ){
				setIsFinished(true);
				props.change(res.owner);
			} else {
				setValues({unique_id:unique_id,password:password});
				setError("ログインできませんでした");
			}
		});
		
	}
	const handleSnackbarClose = (event: Event | React.SyntheticEvent)=>{
		setError("");
	}

	let isError = false;
	if( error!=="" ){
		isError = true;
	}

	if( isFinished ){
		return (
			<Redirect to="/"/>
		)
	}

	return (
		<div id="top1" className={classes.loginForm}>
			<Paper className={classes.paper} style={{marginBottom:"1em"}}>
				<Typography variant="subtitle1" className={classes.withIcon}><AccountBoxIcon style={{marginRight:"0.25em"}}/>ＩＤとパスワードで</Typography>
				<FormControl fullWidth={true}>
					<TextField
						id="login_id"
						label="ＩＤ"
						value={values.unique_id}
						onChange={handleChange('unique_id')}
						margin="dense"
						//className={classes.inputXs}
						variant="outlined"
						fullWidth
					/>
					<TextField
						id="login_pass"
						label="パスワード"
						value={values.password}
						onChange={handleChange('password')}
						margin="dense"
						//className={classes.inputXs}
						variant="outlined"
						type="password"
						fullWidth
					/>
					<Button variant="contained" color="primary" fullWidth={true} onClick={change}>ログイン</Button>
				</FormControl>
				<div style={{textAlign:"right",marginTop:'1em'}}>
					<a href="/customer_new.html" className={classes.link+" "+classes.withIcon}><ArrowForwardIcon/>会員登録はこちら</a><br/>
					<a href="/lost_index.html" className={classes.link+" "+classes.withIcon}><ArrowForwardIcon/>パスワードを忘れたら</a>
				</div>
			</Paper>
			<Paper className={classes.paper}>
				<Typography variant="subtitle1" className={classes.withIcon}><ShareIcon/>ＳＮＳで</Typography>
				<a href="https://store.retro-biz.com/?mod=customer&act=twauth_login&phase=sideb">
					<Button variant="outlined" color="primary" fullWidth={true} style={{marginTop:'0.5em',marginBottom:"0.5em"}}>
						<TwitterIcon style={{marginRight:"0.5em"}}/>Twitter
					</Button>
				</a>
				<a href="https://store.retro-biz.com/?mod=customer&act=gauth_login&phase=sideb">
					<Button variant="outlined" color="primary" fullWidth={true} style={{marginBottom:"1em"}}>
						<GoogleIcon style={{marginRight:"0.5em"}}/>Google
					</Button>
				</a>
				{false &&
				<a href="https://store.retro-biz.com/?mod=customer&act=fbauth_request&phase=sideb">
					<Button variant="contained" color="primary" fullWidth={true} style={{marginBottom:"0.5em"}}>
						<FacebookIcon style={{marginRight:"0.5em"}}/>Facebook
					</Button>
				</a>
				}
				<div style={{textAlign:"right"}}>
					<a href="/customer_new.html" className={classes.link+" "+classes.withIcon}><ArrowForwardIcon/>会員登録はこちら</a><br/>
				</div>
			</Paper>
			<Snackbar
				anchorOrigin={{
				vertical: 'top',
				horizontal: 'center',
				}}
				open={isError}
				autoHideDuration={3000}
				onClose={handleSnackbarClose}
				ContentProps={{
				'aria-describedby': 'message-id',
				}}
				message={<span id="message-id">{error}</span>}
				action={[
				<IconButton
					key="close"
					aria-label="Close"
					color="info"
					onClick={handleSnackbarClose}
				>
					<CloseIcon />
				</IconButton>,
				]}
			/>

		</div>
	);
}

export default Login;
